// extracted by mini-css-extract-plugin
module.exports = {"hero-text":"PlatformsHero_hero-text__nECMk"};